import React from 'react';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { Text, type TextT } from '../text';

export const ErrorMessage = ({ className, ...rest }: TextT) => (
  <Text
    className={clsx('text-text-negative text-87-5 mt-1', className)}
    {...rest}
  />
);
